{
  "RESET_PASSWORD": {
    "TITLE": "Atstatyti slaptažodį",
    "DESCRIPTION": "Įveskite el. pašto adresą, kurį naudojate prisijungdami prie Kontaktų centro, kad gautumėte slaptažodžio atstatymo instrukcijas.",
    "GO_BACK_TO_LOGIN": "Jei norite grįžti į prisijungimo puslapį,",
    "EMAIL": {
      "LABEL": "El. paštas",
      "PLACEHOLDER": "Prašau įveskite jūsų el. paštą.",
      "ERROR": "Prašau įveskite teisingą el. paštą."
    },
    "API": {
      "SUCCESS_MESSAGE": "Slaptažodžio nustatymo iš naujo nuoroda buvo išsiųsta į jūsų el. paštą.",
      "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio. Bandykite dar kartą vėliau."
    },
    "SUBMIT": "Pateikti"
  }
}
